const a = (e) => e && e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([a-zA-Z0-9])\s([a-zA-Z0-9])/g, "$1-$2").replace(/_+/g, "-").replace(/, /g, "-").replace(/[^a-zA-Z0-9\-]/g, "-").replace(/-+/g, "-").replace(/^-+|-+$/g, "").toLowerCase();
export {
  a as convertToKebabCase
};
